module.exports = __webpack_public_path__ + "static/media/arrow-down.134ee96f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-down.svg
// module id = 318
// module chunks = 0